import * as React from 'react';
import { connect } from 'react-redux';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentRetakePageView } from '../components';
import { getCapturedUploadPhotoFiles, getIntelligentSequenceScreenName, getShouldAllowMitchellIntelligent, getIntelligentPhotoCaptureImageDetail, getShouldEnableAdditionalOption } from '../selectors';
const mapStateToProps = (state) => ({
    questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
    sequenceScreenName: getIntelligentSequenceScreenName(state),
    shouldAllowMitchellIntelligent: getShouldAllowMitchellIntelligent(state),
    files: getCapturedUploadPhotoFiles(state),
    iqaScores: getIntelligentPhotoCaptureImageDetail(state),
    shouldEnableAdditionalOption: getShouldEnableAdditionalOption(state)
});
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    }
});
const PhotoCaptureRetakePageViewWrapper = (props) => React.createElement(IntelligentRetakePageView, Object.assign({}, props));
export const ConnectedIntelligentRetakePageView = connect(mapStateToProps, mapDispatchToProps)(PhotoCaptureRetakePageViewWrapper);
//# sourceMappingURL=ConnectedIntelligentRetakePageView.js.map